export const environment = {
  production: false,
  zuoraApiUrl: 'https://sprucepowerzuoraapi-dev.azurewebsites.net',
  dwApiUrl: 'https://sprucepoweredwapi-dev.azurewebsites.net',
  zendeskApiUrl: 'https://sprucepowerzendeskapi-dev.azurewebsites.net',
  managementApiUrl: 'https://sprucepowerauth0managedapi-dev.azurewebsites.net/user/',
  auth0ClientId: 'JX8LrCM60r6MYYpC5ozbUtbzpVPWkLWd',
  auth0Domain: 'auth.sprucepowerdev.com',
  auth0Audience: 'https://dev-506jdu5v1gxbxa34.us.auth0.com/api/v2/',
  ticket: '18959145633171',
  ticketGroup: '1500006600681',
  partnerShipGroup: '4414661954067',
  billing: '18959104424467',
  operations: '1500012949002',
  support: '18959104424467',
  host: '1500012949002',
  callbackGroup: '26634899826579',
  scriptId: '170431335',
  skillNo: '4035448',
  solarAgreementOrPrepaymentFormId: '6788195402387',
  homeSaleAndSolarAgreementFormId: '6787849111187',
  refinanceFormId: '12704954889747',
  solarAgreementOrPrepaymentGroupId: '12760273408147',
  homeSaleAndSolarAgreementGroupId: '8718226729619',
  refinanceGroupId: '8718243311123',
  systemFieldId: '4610033178643',
  accountFieldId: '19574366898451'
};